import { useState } from "react";
import { Col, Container, Form, Image, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useBetween } from "use-between";
import AwareButton from "../../components/button";
import { useAuthApi } from "../useApi";
import "./index.scss";
import { toast } from "react-toastify";

const Forgot = () => {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const { forgot } = useBetween(useAuthApi);

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = {
            username: name,
        };

        forgot(formData).then((res) => {
            navigate("/login");
            toast.success(res.message);
        });
    };

    return (
        <Container fluid className='register-container'>
            <Row className='vh-100'>
                <Col
                    md={5}
                    className='px-0 register-banner vh-100 d-none d-md-block position-relative'
                >
                    <Image
                        src='https://mammoth-product-images.s3.us-west-1.amazonaws.com/Images/login/login-screen.png'
                        alt='background'
                        fluid
                    />
                </Col>
                <Col className='register-form-wrapper'>
                    <Form
                        className='h-100 d-flex align-items-center'
                        onSubmit={(e) => {
                            handleSubmit(e);
                        }}
                    >
                        <Row className='register-form-inner'>
                            <Col sm={12}>
                                <h1>Forgot Password?</h1>
                            </Col>
                            <Col sm={12}>
                                <p>
                                    To request a password reset, please fill out
                                    the form below.
                                </p>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className='form-group'>
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                        type='text'
                                        value={name}
                                        onChange={(event) =>
                                            setName(event.target.value)
                                        }
                                        placeholder='Username'
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12} className='text-center'>
                                <AwareButton
                                    type='submit'
                                    className='w-100 primary  btn-primary'
                                >
                                    Submit
                                </AwareButton>
                                <Link className='btn-create' to='/login'>
                                    Back to Login
                                </Link>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default Forgot;
